export function validate(parameters: any): { valid: boolean; errors: string[] } {
  const errors: string[] = [];
  
  if (!parameters.workflowId || parameters.workflowId.trim() === '') {
    errors.push('Workflow ID is required');
  }
  
  if (parameters.inputDataMode === 'defineFields' && (!parameters.inputMapping || Object.keys(parameters.inputMapping).length === 0)) {
    errors.push('At least one field mapping is required when using "Define Using Fields" mode');
  }
  
  if (parameters.inputDataMode === 'defineJson') {
    try {
      if (!parameters.inputJson || parameters.inputJson.trim() === '') {
        errors.push('Input JSON is required when using "Define Using JSON" mode');
      } else {
        JSON.parse(parameters.inputJson);
      }
    } catch (e) {
      errors.push('Input JSON must be valid JSON');
    }
  }
  
  return { valid: errors.length === 0, errors };
}
